import envVar from '../config/envVars';
import { ScoringTypeFormData } from '../modules/ScoringTypes/types/scoringType';
import httpGet from './httpClient/httpGet';
import httpPost from './httpClient/httpPost';
import httpDelete from './httpClient/httpDelete';

const getScoringTypes = async (school: string) => {
  return httpGet(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/scoring-types`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const upsertScoringType = async (school: string, data: ScoringTypeFormData) => {
  return httpPost(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/${school}/scoring-types`,
    data,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const deleteScoringType = async (id: string) => {
  return httpDelete(
    `${envVar.REACT_APP_EXAM_BASE_URL}/schools/scoring-types/${id}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_EXAM_ACCESS_TOKEN}`
      }
    }
  );
};

const scoringTypes = {
  getScoringTypes,
  upsertScoringType,
  deleteScoringType
};

export default scoringTypes;
